import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import { ExperimentStepType } from "@ane/exp-data/lib/models";
import { TransitionGateType } from "./GatingUtils.types.js";
const SeedFinderOverrideStatus = "Seedfinder has been skipped. See log tab to the left for more info.";
const getAdditionalInfoForGate = (gateType) => {
  if (compareIgnoreCase(gateType, ExperimentStepType.SeedFinder)) {
    return {
      Status: SeedFinderOverrideStatus
    };
  }
  return null;
};
const IsByFlight = (gateType) => {
  return gateType === (TransitionGateType.StartTrafficByFlight || TransitionGateType.AdvanceTrafficByFlight || TransitionGateType.StartAndAdvanceTrafficByFlight);
};
export {
  IsByFlight,
  getAdditionalInfoForGate
};
//# sourceMappingURL=GatingUtils.js.map
